import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'addText',
    standalone: false
})
export class AddTextPipe implements PipeTransform {
    transform(value: any, ...args: any[]): string {
        return value + ' ' + args?.[0];
    }
}
